export function documentWeightColumns(columns = [], packing = false) {
  columns = (Array.isArray(columns) ? columns : []).filter(c => c && typeof c.field === "string" && c.field);
  return columns.map(c => ({ ...c }));
}

// Edits must use the same column indexes as the rendered template.
// Schema migration belongs at load time, never between render and an edit.
export function editDocumentTemplate(template, edit) {
  const next = JSON.parse(JSON.stringify(template));
  edit(next);
  return next;
}
